import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { comparison } from '../../data/content';
export function InnerCircle() {
  return <section className="py-24 relative bg-surface border-y border-line" data-id="element-145" data-mp="1b4boi6yxaac0">
      <div className="container mx-auto px-4" data-id="element-146" data-mp="wafhcbei7nqd">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-147" data-mp="1188r1ef0mzve">
          <div className="inline-block px-4 py-1.5 rounded-full bg-pistachio-200 text-pistachio-800 text-xs font-bold tracking-widest uppercase mb-6" data-id="element-148" data-mp="118h3543be15j">
            <span aria-hidden="true" data-id="element-149" data-mp="1txfkw03iz1ab">⭐</span> SISTEMA TOTAL — LA ÚLTIMA PIEZA
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-ink mb-6" data-id="element-150" data-mp="1f89mufgfbh40">
            + Método Cocina Impecable
          </h2>
          <div className="space-y-4 text-muted text-lg" data-id="element-151" data-mp="1k5rywepqmcg8">
            <p data-id="element-152" data-mp="27wxecsrrn2q0">
              Ahora que tenés la comida lista, hay una última pieza para la libertad total:
              la cocina ordenada y limpia en 15 minutos diarios.
            </p>
            <p data-id="element-153" data-mp="jbphbk51t0fg">
              Sin productos carísimos. Sin horas de limpieza. Sin el caos post-batch cooking
              que hace que el domingo de preparación se sienta más largo de lo que es.
            </p>
          </div>
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-154" data-mp="t2kcxf46pcdk">
          <p className="md:hidden text-center text-sm text-muted mb-4" data-id="element-155" data-mp="t3c144vgc7tt">
            ← Deslizá para ver la tabla completa →
          </p>
          <div className="overflow-x-auto hide-scrollbar rounded-2xl border border-line" data-id="element-156" data-mp="121e8d25s3wpj">
            <table className="w-full min-w-[800px] text-left border-collapse" data-id="element-157" data-mp="x3m4d9rv0k4z">
              <thead data-id="element-158" data-mp="1c0d5bnh6m3wp">
                <tr className="border-b border-line bg-pistachio-50" data-id="element-159" data-mp="1c0wmv32x6qa7">
                  <th className="p-5 font-semibold text-ink w-1/3" data-id="element-160" data-mp="171acr2ie1q5m">Situación</th>
                  <th className="p-5 font-semibold text-muted w-1/3" data-id="element-161" data-mp="16z7btnfp6cm4">
                    <span className="flex items-center gap-2" data-id="element-162" data-mp="3dsj9ytjoy11e">
                      <XCircleIcon size={18} className="text-clay-600" aria-hidden="true" data-id="element-163" data-mp="38swxwnflmqu6" />{' '}
                      Sin Sistema Total
                    </span>
                  </th>
                  <th className="p-5 font-semibold text-pistachio-800 w-1/3" data-id="element-164" data-mp="6d03ytu1glqc">
                    <span className="flex items-center gap-2" data-id="element-165" data-mp="6f2rn77py2rw">
                      <CheckCircle2Icon size={18} aria-hidden="true" data-id="element-166" data-mp="bbbcn18lkq6z" /> Con Sistema Total
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-line" data-id="element-167" data-mp="lase16gtghx5">
                {comparison.map(row => <tr key={row.sit} className="hover:bg-pistachio-50/60 transition-colors" data-id="element-168" data-mp="pb2lyoo65ien">
                    <td className="p-5 text-ink text-sm font-medium" data-id="element-169" data-mp="u22jnw5444i7">{row.sit}</td>
                    <td className="p-5 text-muted text-sm" data-id="element-170" data-mp="z1nq0rmm3f4y">{row.sin}</td>
                    <td className="p-5 text-pistachio-900 text-sm font-medium bg-pistachio-100/70" data-id="element-171" data-mp="z3rtx9kige58">
                      {row.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}